import { render } from "./mistake_menu.vue?vue&type=template&id=1d0956a0"
import script from "./mistake_menu.vue?vue&type=script&lang=js"
export * from "./mistake_menu.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__